var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"type":"is-primary","position":"is-right","label":_vm.label}},[_c('b-icon',{attrs:{"icon":_vm.icon,"size":"is-small","type":"is-primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }